<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-left`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.54785 3.33496C2.91508 3.33496 3.21282 3.63279 3.21289 4V12C3.21289 12.3673 2.91512 12.665 2.54785 12.665C2.18058 12.665 1.88281 12.3673 1.88281 12V4C1.88288 3.63279 2.18062 3.33496 2.54785 3.33496ZM7.67285 4.0293C7.93252 3.76965 8.35456 3.76971 8.61426 4.0293C8.87395 4.28899 8.87394 4.711 8.61426 4.9707L6.25 7.33496H13.4521C13.8194 7.33496 14.1171 7.63279 14.1172 8C14.1172 8.36727 13.8194 8.66504 13.4521 8.66504H6.25L8.61426 11.0293C8.87395 11.289 8.87394 11.711 8.61426 11.9707C8.35456 12.2304 7.93255 12.2304 7.67285 11.9707L4.17285 8.4707C3.91326 8.211 3.91319 7.78896 4.17285 7.5293L7.67285 4.0293Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineLeft',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
